/* eslint-disable prettier/prettier */
/* eslint-disable */

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
export const isCrios = window.navigator.userAgent.match('CriOS');
export const isDeviceMobile = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) || navigator.userAgent.toLowerCase().match(/(ipad|iphone)/));
export const detectTouchDevice = () => (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || ((navigator as any)?.msMaxTouchPoints > 0));
